import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../components/common/Sidebar';

// OrgUser Components
import OrgUserHome from '../components/dashboard/OrgUser/OrgUserHome';
import CreditCheckOrgUser from '../components/dashboard/OrgUser/CreditCheckOrgUser';
import CreditCheckWithOTP from '../components/dashboard/OrgUser/CreditCheckWithOTP';
import CreditCheckWithoutOTP from '../components/dashboard/OrgUser/CreditCheckWithoutOTP';
import CreditReportsOrgUser from '../components/dashboard/OrgUser/CreditReportsOrgUser';
import WalletOrgUser from '../components/dashboard/OrgUser/WalletOrgUser';
import KycPanVerification from '../components/dashboard/OrgUser/KycPanVerification';
import KycPanToBankAccount from '../components/dashboard/OrgUser/KycPanToBankAccount';
import KycMobileToBankAccount from '../components/dashboard/OrgUser/KycMobileToBankAccount';
import KycCourtCaseCheck from '../components/dashboard/OrgUser/KycCourtCaseCheck';
import KycDlVerification from '../components/dashboard/OrgUser/KycDlVerification';
import KycRcVerification from '../components/dashboard/OrgUser/KycRcVerification';
import UploadDataManagement from '../components/dashboard/shared/UploadDataManagement';
import SupportTicketManagement from '../components/dashboard/shared/SupportTicketManagement';
import ActivityLogs from '../components/dashboard/OrgUser/ActivityLogs';
import Notifications from '../components/dashboard/shared/Notifications';
import OrgUserProfile from '../components/dashboard/OrgUser/OrgUserProfile';

export default function OrgUserPortal() {
  return (
    <div className="dashboard-layout">
      <Sidebar role="orguser" />
      <div className="dashboard-content">
        <Routes>
          <Route path="/" element={<OrgUserHome />} />
          <Route path="credit-checks" element={<CreditCheckOrgUser />} />
          <Route path="credit-checks/with-otp" element={<CreditCheckWithOTP />} />
          <Route path="credit-checks/without-otp" element={<CreditCheckWithoutOTP />} />
          <Route path="kyc/pan-verification" element={<KycPanVerification />} />
          <Route path="kyc/pan-to-bank-account" element={<KycPanToBankAccount />} />
          <Route path="kyc/mobile-to-bank-account" element={<KycMobileToBankAccount />} />
          <Route path="kyc/court-case-check" element={<KycCourtCaseCheck />} />
          <Route path="kyc/dl-verification" element={<KycDlVerification />} />
          <Route path="kyc/rc-verification" element={<KycRcVerification />} />
          <Route path="credit-reports" element={<CreditReportsOrgUser />} />
          <Route path="wallet" element={<WalletOrgUser />} />
          <Route path="upload-data" element={
            <UploadDataManagement
              role="orguser"
              uploadEndpoint="/orguser/data-upload/upload"
              historyEndpoint="/orguser/data-upload/history"
              authHeader={() => require('../services/orgUserAuth.service').default.getAuthHeader()}
            />
          } />
          <Route path="support-tickets" element={<SupportTicketManagement role="orguser" />} />
          <Route path="activity-logs" element={<ActivityLogs />} />
          <Route path="notifications" element={<Notifications role="orguser" />} />
          <Route path="profile" element={<OrgUserProfile />} />
        </Routes>
      </div>
    </div>
  );
}
